module.exports = __webpack_public_path__ + "static/media/fondo.3af5796f.jpg";